import { render, staticRenderFns } from "./LoginPanel.vue?vue&type=template&id=508f08a6&scoped=true&"
import script from "./LoginPanel.vue?vue&type=script&lang=js&"
export * from "./LoginPanel.vue?vue&type=script&lang=js&"
import style0 from "./LoginPanel.vue?vue&type=style&index=0&id=508f08a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f08a6",
  null
  
)

export default component.exports